import apiFactory from '@/api/default';
const API = apiFactory('tags');

const state = {
  tagSearchResults: [],
  currentTag: {},
};

const getters = {
  tagSearchResults: (state) => state.tagSearchResults,
  currentTag: (state) => state.currentTag,
};

const mutations = {
  setTagSearchResults: (state, tagSearchResults) => {
    state.tagSearchResults = tagSearchResults;
  },
  removeFromTagSearchResults: (state, id)=>{
    state.tagSearchResults.data = state.tagSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.tagSearchResults.total--;
  },
  setCurrentTag: (state, currentTag) => {
    state.currentTag = currentTag;
  },
  updateCurrentTagProperties: (state, properties) => {
    for (const key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        state.currentTag[key] = properties[key];
      }
    }
  },
};

const actions = {
  async searchTags({commit}, data) {
    const response = await API.search(data.query);
    if (data.setResultsInStore) {
      commit('setTagSearchResults', response.data);
    }
    return response.data;
  },
  async loadTag({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentTag', response.data);
    return response.data;
  },
  async createTag({commit, state}, data) {
    const itemIndex = state.tagSearchResults.findIndex((item) => item.name === data.name);
    if (itemIndex < 0) {
      const response = await API.create(data);
      return response.data;
    } else {
      return state.tagSearchResults[itemIndex];
    }
  },
  async updateTag({commit}, payload) {
    const response = await API.update(payload.id, payload.props);
    // If the update is successful update currentTag with the supplied props
    commit('updateCurrentTagProperties', payload.props);
    return response.data;
  },
  async deleteTag({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromTagSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
